import { Descriptions } from "antd";
import { useTranslation } from "react-i18next";
import { AllergenTagList } from "../../../components/AllergenTagList.tsx";
import { formatDateTime } from "../../../utils/datetime.ts";
import { fitContent } from "../../../styles/shared.styles.ts";
import { useIngredient } from "../IngredientContext.tsx";
import { description } from "../IngredientDetailPage.styles.ts";

export const IngredientGeneralTab = () => {
  const { t, i18n } = useTranslation();
  const { ingredient } = useIngredient();

  return (
    <Descriptions bordered className={fitContent} column={1} size="small">
      <Descriptions.Item label={t("ingredients.nameForLabel")}>{ingredient.nameForLabel ?? "\u2014"}</Descriptions.Item>
      <Descriptions.Item label={t("ingredients.brand")}>{ingredient.brand ?? "\u2014"}</Descriptions.Item>
      <Descriptions.Item label={t("ingredients.description")}>
        {ingredient.description ? <span className={description}>{ingredient.description}</span> : "\u2014"}
      </Descriptions.Item>
      <Descriptions.Item label={t("ingredients.allergens")}>
        {ingredient.allergens.length === 0 ? "\u2014" : <AllergenTagList allergens={ingredient.allergens} />}
      </Descriptions.Item>
      <Descriptions.Item label={t("ingredients.createdAt")}>
        {formatDateTime(ingredient.createdAt, i18n.language)}
      </Descriptions.Item>
      <Descriptions.Item label={t("common.createdBy")}>{ingredient.createdBy.name}</Descriptions.Item>
      <Descriptions.Item label={t("ingredients.updatedAt")}>
        {formatDateTime(ingredient.updatedAt, i18n.language)}
      </Descriptions.Item>
    </Descriptions>
  );
};
